export default __webpack_public_path__ + "static/media/whatsapp-logo.63cf4260.png";